import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_BASE from "../config/api";

function BusinessProfile() {
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/api/businessProfiledata.php?id=${id}`)
            .then((res) => res.json())
            .then((result) => setData(result.data))   // IMPORTANT FIX
            .catch((err) => console.log(err));
    }, [id]);

    if (!data) {
        return <div className="text-center py-5">Loading...</div>;
    }

    return (
        <div className="container my-4">

            {/* COVER IMAGE */}
            <div className="card border-0 shadow-sm mb-4">
                <img
                    src={`${API_BASE}/uploads/${data.cover}`}
                    alt="cover"
                    className="w-100"
                    style={{ height: "280px", objectFit: "cover" }}
                />
            </div>

            {/* PROFILE PIC */}
            <div className="text-center mb-4">
                <img
                    src={`${API_BASE}/assets/profile.jpg`}
                    alt="profile"
                    className="rounded-circle border border-3"
                    style={{
                        width: "250px",
                        height: "250px",
                        objectFit: "cover",
                        marginTop: "20px",
                    }}
                />

                <h3 className="fw-bold mt-3 mb-1">
                    {data.name || "Business Name"}
                </h3>

                <span className="badge bg-success mb-2">
                    <i className="bi bi-patch-check-fill me-1"></i>
                    {data.verified ? "Verified Business" : "Unverified"}
                </span>

                <p className="text-muted small">
                    <i className="bi bi-geo-alt-fill text-primary me-1"></i>
                    {data.address || "Location not available"}
                </p>

                {/* Action Buttons */}
                <div className="d-flex justify-content-center gap-2 mt-2">
                    <a href={`tel:${data.phone}`} className="btn btn-success btn-sm">
                        <i className="bi bi-telephone-fill me-1"></i> Call
                    </a>
                    <a
                        href={data.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-sm"
                    >
                        <i className="bi bi-globe me-1"></i> Website
                    </a>
                    <button className="btn btn-warning btn-sm text-dark">
                        <i className="bi bi-chat-left-text me-1"></i> Message
                    </button>
                </div>
            </div>

            {/* ABOUT */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-2">About</h5>
                <p className="text-muted">
                    {data.about ||
                        "This business provides premium services with excellent customer satisfaction."}
                </p>
            </div>

            {/* FACILITIES */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Facilities</h5>
                <div className="d-flex flex-wrap gap-2">
                    {(data.facilities || []).map((item, index) => (
                        <span key={index} className="badge bg-light text-dark">
                            {item}
                        </span>
                    ))}
                </div>
            </div>

            {/* CONTACT INFORMATION */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Contact Information</h5>

                <ul className="list-unstyled">
                    <li className="mb-2">
                        <i className="bi bi-telephone-fill text-success me-2"></i>
                        {data.phone}
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-envelope-fill text-danger me-2"></i>
                        {data.email}
                    </li>
                    <li>
                        <i className="bi bi-globe text-primary me-2"></i>
                        {data.website}
                    </li>
                </ul>
            </div>

            {/* OPENING HOURS */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Opening Hours</h5>

                <ul className="list-group">
                    {(data.hours || []).map((h, i) => (
                        <li
                            key={i}
                            className="list-group-item d-flex justify-content-between"
                        >
                            <span>{h.day}</span>
                            <span>{h.time}</span>
                        </li>
                    ))}
                </ul>
            </div>

            {/* GALLERY */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Gallery</h5>

                <div className="row g-3">
                    {(data.gallery || []).map((img, index) => (
                        <div className="col-md-4" key={index}>
                            <img
                                src={img}
                                alt="gallery"
                                className="img-fluid rounded"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* MAP PLACEHOLDER */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Location Map</h5>
                <div
                    className="bg-light rounded d-flex justify-content-center align-items-center"
                    style={{ height: "250px" }}
                >
                    <p className="text-muted">Map placeholder</p>
                </div>
            </div>
        </div>
    );
}

export default BusinessProfile;
